/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;

  .fill {
    color: inherit;
  }
`
export default class CircleCheckIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" css={Color}>
        <g id="그룹_15567" data-name="그룹 15567" transform="translate(-361 -707)">
          <rect id="사각형_9482" data-name="사각형 9482" width="30" height="30" transform="translate(361 707)" fill="#5c5c5c" opacity="0"/>
          <g id="그룹_15043" data-name="그룹 15043" transform="translate(-1006 -22)">
            <path id="빼기_49" className="fill" data-name="빼기 49" d="M10751,12837a8,8,0,1,1,8-8A8.007,8.007,0,0,1,10751,12837Zm-3.092-8.588a.735.735,0,0,0-.52.212.748.748,0,0,0-.228.529.737.737,0,0,0,.212.53l2.577,2.661a.737.737,0,0,0,.538.229h.02a.756.756,0,0,0,.547-.258l4.053-4.662a.748.748,0,0,0-.562-1.241.755.755,0,0,0-.568.259l-3.519,4.043-2.011-2.074A.746.746,0,0,0,10747.907,12828.412Z" transform="translate(-9369 -12085)" fill="#5c5c5c"/>
          </g>
        </g>
      </svg>
    )
  }
}
